import { colors, Typography } from '@sweep-io/sweep-design';
import { ConfigurationTypesWithIcon } from '../../types';
import Box from '@mui/material/Box';
import { DotDivider } from '../../../../common/DotDivider';
import { InactiveTag } from '../../../activity-state/InactiveTag';
import { getChips } from '../../helpers';
import { configurationItemTypeToIcon } from '../../latest-deployed/templates/organisms/helpers/icons';
import { getItemType } from '../utils';
import RuleChips from '../../../shared/RuleChips';
import { ConfigurationItem, hasFieldProperties } from '../../../../parser/ConfigurationItemTypes';
import { useSelector } from 'react-redux';
import { selectSaltoObjectTypes } from '../../../../../reducers/global/parserReducer';
import { isItemActive } from '../../../helpers';
import { FIELD } from '@server/parser';
import { ROLLUP } from '../../../../parser/ConfigurationItemTypes';

interface TitleWithSubtitleProps {
  configurationItem: ConfigurationItem;
  parentType?: string;
  crmOrgId: string;
}

export const TitleWithSubtitle = ({
  configurationItem,
  parentType,
  crmOrgId,
}: TitleWithSubtitleProps) => {
  const saltoObjectTypes = useSelector(selectSaltoObjectTypes(crmOrgId));

  const isField = parentType === FIELD || parentType === ROLLUP;

  const fieldConfigurationItem =
    isField && hasFieldProperties(configurationItem) ? configurationItem : undefined;

  const { label, isActive, objectApiNames, stagesNames } = configurationItem;
  const _usage = 'usage' in configurationItem ? configurationItem.usage : undefined;

  const { chips, RTchips } = getChips(configurationItem, stagesNames ?? [], saltoObjectTypes ?? []);
  const _objectName = objectApiNames?.[0];

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" gap={1} alignItems="center">
        <Typography variant="h4-medium" whiteSpace="break-spaces" wordBreak="break-word">
          {label}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        gap={0.5}
        alignItems="center"
        sx={{ svg: { path: { stroke: colors.grey[700] } } }}
      >
        {parentType && (
          <>
            {configurationItemTypeToIcon[parentType as ConfigurationTypesWithIcon]}
            <Typography variant="caption" color={colors.grey[700]} whiteSpace="nowrap">
              {getItemType({
                saltoObjectTypes: saltoObjectTypes ?? [],
                _objectName,
                parentType,
                dependencyType: fieldConfigurationItem?.fieldType ?? '',
              })}
            </Typography>
          </>
        )}

        {(chips?.filter((chip) => !!chip).length > 0 || RTchips?.length > 0) && (
          <>
            <DotDivider />
            <RuleChips
              chips={chips}
              differentColorChips={RTchips}
              differentColor={colors.grey[120]}
            />
          </>
        )}

        {isField && 'usage' in configurationItem && (
          <Box display="flex" alignItems="center" gap={0.5}>
            <DotDivider />
            <Typography variant="caption" color={colors.grey[700]}>
              {_usage}% usage
            </Typography>
          </Box>
        )}

        {!isItemActive(configurationItem) && (
          <Box display="flex" alignItems="center" gap={0.5}>
            <DotDivider />
            <InactiveTag isActive={!!isActive} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
